/**
 * Authentication and session token utilities for securing API requests.
 */

export function getClientAuthToken(): string {
  try {
    if (typeof window === 'undefined') return 'server_session';
    
    // Check authenticated user session first
    const saved = localStorage.getItem('vdp_current_user_session');
    if (saved) {
      const parsed = JSON.parse(saved);
      if (parsed?.uid && typeof parsed.uid === 'string') {
        return parsed.uid;
      }
    }

    // Check or generate persistent anonymous session token
    let anon = localStorage.getItem('vdp_anon_session');
    if (!anon || typeof anon !== 'string') {
      anon = `anon_${Date.now().toString(36)}_${Math.random().toString(36).substring(2, 10)}`;
      localStorage.setItem('vdp_anon_session', anon);
    }
    return anon;
  } catch {
    return 'anon_guest_session';
  }
}
